<template>
  <component :is="dashboardType" />
</template>

<script>
import { mapGetters } from 'vuex';
import PlatformDashboard from './Platform';
import TabbedDashboard from '@/components/Platform/Dashboards/TabbedDashboard';

export default {
  name: 'Dashboards',
  components: {
    PlatformDashboard,
    TabbedDashboard
  },
  data: () => ({
    dashboardType: {}
  }),
  computed: {
    ...mapGetters(['UserHasRole'])
  },
  created() {
    if (this.UserHasRole('Platform')) {
      this.dashboardType = PlatformDashboard;
    } else {
      this.dashboardType = TabbedDashboard;
    }
  }
};
</script>
